import { StablesOperationPage } from "./StablesOperationPage";

export const StablesSwap = () => (
  <StablesOperationPage
    operation="swap"
    title="Swap entre stablecoins"
    subTitle="Troque entre as stables disponíveis na sua carteira. Acompanhe seus swaps no histórico abaixo."
    historyType="swaps"
    historyTitle="Histórico de conversões"
  />
);
